import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router-dom';
//UI
import BtnDashboard from '../../buttons/BtnDashboard';
//RESOURCERS
import { useToolbarStore } from '../../../store/VitalStore';
import politics from '../../../assets/icons/politics.svg'
import diploma  from '../../../assets/icons/diploma.svg'

const AdminList = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const { closeToolbar } = useToolbarStore((state) => state);

    return (
        <div className='w-[100%]'>
            <div className='pl-2 text-[10px] font-semibold uppercase text-start text-sky-700'>{t("administration_tag")}</div>
            <li
                onClick={(e) => { navigate('/politica_privacidad'); closeToolbar(); }}
                className={`w-full ${location.pathname.startsWith('/politica_privacidad') ? 'active' : ''}`}>
                <BtnDashboard>
                    <img src={politics} className='w-6 h-6' />
                    <p>{t("Politica de privacidad")}</p>
                </BtnDashboard>
            </li>
            <li
                onClick={(e) => { navigate('/inicio'); closeToolbar(); }}
                className={`w-full text-start ${location.pathname.startsWith('/inicio') ? 'active' :
                    location.pathname.startsWith('/proceso_matriculacion') ? 'active' : ''}`}>
                <BtnDashboard>
                    <img src={diploma} className='w-6 h-6' />
                    <p>{t("Reservación Cupo / Matriculación")}</p>
                </BtnDashboard>
            </li>
        </div>
    );
};

export default AdminList;